import { Injectable } from '@angular/core';
import { catchErrorTo } from '@lycoris-nubila/ngx-lycoris';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApplicationAdapter } from 'application/application.adapter';
import { UserContactCompanyOutput } from 'user/model/contact/user-contact-company.output';
import { UserContactCompanyApiPort } from 'user/port/contact/user-contact-company-api.port';
import { UserContactCompanyApplicationPort } from 'user/port/contact/user-contact-company-application.port';

@Injectable()
export class UserContactCompanyApplicationAdapter
	extends ApplicationAdapter
	implements UserContactCompanyApplicationPort
{
	constructor(
		translateService: TranslateService,
		private _userContactCompanyApiPort: UserContactCompanyApiPort
	) {
		super(translateService);
	}

	public fetchUserContactCompanies(): Observable<
		UserContactCompanyOutput[] | Error
	> {
		return this._userContactCompanyApiPort
			.fetchUserContactCompanies()
			.pipe(
				catchError(() =>
					of(
						Error(this._buildInfrastructureErrorMessage('fetchUserContactCompanies'))
					)
				)
			);
	}
}
